<!-- 供水厂详情 -->
<template>
  <div class="dialog-supply">
    <div class="header">
      <div class="title">{{ data.scmc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">水厂类型:</span>
            <span class="value">{{ data.sclx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">管理范围面积（K㎡）:</span>
            <span class="value">{{ data.glfwmj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">保护范围面积（K㎡）:</span>
            <span class="value">{{ data.bhfwmj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">供水范围:</span>
            <span class="value">{{ data.gsfw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">供水规模:</span>
            <span class="value">{{ data.gsgm || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">供水人口:</span>
            <span class="value">{{ data.gsrk || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">供水水厂个数:</span>
            <span class="value">{{ data.gsscgs || '-' }}</span>
          </div>

          <div class="descriptions-item">
            <span class="key">工程状态:</span>
            <span class="value">
              <span v-if="data.value == 1">已建</span>
              <span v-else>在建</span>
              <!-- <n-radio-group v-model:value="data.value" name="radiogroup">
                <n-space>
                  <n-radio :value="1">已建</n-radio>
                  <n-radio :value="0">在建</n-radio>
                </n-space>
              </n-radio-group> -->
            </span>
          </div>
          <div class="descriptions-item">
            <span class="key">供水水厂组成:</span>
            <span class="value">{{ data.gssczc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">取水水源:</span>
            <span class="value">{{ data.qssy || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">日均供水能力（吨）:</span>
            <span class="value">{{ data.rjgsnl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">日最大峰值供水能力（吨）:</span>
            <span class="value">{{ data.rzdfgsnl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所在河流:</span>
            <span class="value">{{ data.szhl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所在镇街:</span>
            <span class="value">{{ data.xzqhmc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">详细地址:</span>
            <span class="value">{{ data.xxdz || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-supply {
  width: 64.75rem;
  min-width: 64.75rem;
  .header {
    text-align: left;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;
          &:last-of-type {
            width: 100%;
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 17.2rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
